import { useMemo, useState } from "react";
import { useConfigStore } from "../../stores/ConfigStore";
import MultiSelector from "./MultiSelector";
import { getFields } from "../../api/ContactAPI";

function getOptionName(option) {
  return `${option.name}`;
}

const DatafieldsSelector = ({
  label,
  placeholder,
  size,
  values,
  onChange,
  disabled,
  leftSection,
  ...props
}) => {
  const datafields = useConfigStore((s) => s.datafields);
  const [loading, setLoading] = useState(false);
  const handleLoad = () => {
    setLoading(true);
    getFields().finally(() => setLoading(false));
  };

  const options = useMemo(() => {
    return datafields.map((list) => ({
      ...list,
      option_name: getOptionName(list),
    }));
  }, [datafields]);

  return (
    <MultiSelector
      options={options}
      label={label}
      onDropdownOpen={handleLoad}
      loading={loading}
      values={
        values
          ?.map((listId) => {
            let list = datafields?.find((x) => x.id === listId);
            if (list) {
              return {
                ...list,
                option_name: getOptionName(list),
              };
            }
            return;
          })
          ?.filter(Boolean) || []
      }
      onChange={onChange}
      placeholder={placeholder}
      leftSection={leftSection}
      rightOptionSection={(item) => {
        return (
          item?.id && (
            <span style={{ fontSize: 10, opacity: 0.35 }}>#{item?.id}</span>
          )
        );
      }}
      size={size}
      disabled={disabled}
      w={"100%"}
      searchable
      checkIconPosition="left"
      withDropdown
      autoFocus={false}
      {...props}
    />
  );
};

export default DatafieldsSelector;
